import React from 'react';
import { PropTypes } from 'prop-types';
import DropdownBase from './DropdownBase';
import Lang from '../language/services/Lang';

const ProvinceDropdown = (props) => {
    let { lang } = props;
    const options = [
        { value: 'AB', label: Lang.getValue('common.provinces.ab', lang) },
        { value: 'BC', label: Lang.getValue('common.provinces.bc', lang) },
        { value: 'MB', label: Lang.getValue('common.provinces.mb', lang) },
        { value: 'NB', label: Lang.getValue('common.provinces.nb', lang) },
        { value: 'NL', label: Lang.getValue('common.provinces.nl', lang) },
        { value: 'NS', label: Lang.getValue('common.provinces.ns', lang) },
        { value: 'NT', label: Lang.getValue('common.provinces.nt', lang) },
        { value: 'NU', label: Lang.getValue('common.provinces.nu', lang) },
        { value: 'ON', label: Lang.getValue('common.provinces.on', lang) },
        { value: 'PE', label: Lang.getValue('common.provinces.pe', lang) },
        { value: 'QC', label: Lang.getValue('common.provinces.qc', lang) },
        { value: 'SK', label: Lang.getValue('common.provinces.sk', lang) },
        { value: 'YT', label: Lang.getValue('common.provinces.yt', lang) }
    ]

    return (
        <DropdownBase {...props} options={options} placeholderKey='common.select-placeholder' extraClasses='' />
    );
}

ProvinceDropdown.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired
};


export default ProvinceDropdown;
